import { render, staticRenderFns } from "./HubAuthorize.vue?vue&type=template&id=46cce4eb&"
import script from "./HubAuthorize.vue?vue&type=script&lang=js&"
export * from "./HubAuthorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports